import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { PATHS } from 'shared/consts/paths';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 560px;
    gap: 10px;
`;

const CtaButton = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 58px;
    background: #1268fb;
    color: #fff;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    transition: background 0.2s;
    &:hover {
        background: #1060ea;
        color: #fff;
        text-decoration: none;
    }
`;

const SubText = styled.p`
    margin: 0;
    font-size: 13px;
    color: #6b7280;
    text-align: center;
`;

const UploadCta: React.FC = () => (
    <Wrapper>
        <CtaButton to={PATHS.HOME_UPLOAD}>Upload a CSV and validate your phone list</CtaButton>
        <SubText>No account required &middot; Results in under 60 seconds</SubText>
    </Wrapper>
);

export default UploadCta;
